import clsx from 'clsx'
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react'

interface Props {
  value: number
  
  inverse?: boolean
  
  suffix?: string
  
  format?: (n: number) => string
  className?: string
}

export function Delta({ value, inverse = false, suffix = ' %', format, className }: Props) {
  const dir = value === 0 ? 0 : value > 0 ? 1 : -1
  const Icon = dir === 0 ? Minus : dir > 0 ? ArrowUpRight : ArrowDownRight
  const good = inverse ? dir < 0 : dir > 0
  const bad = inverse ? dir > 0 : dir < 0
  const text =
    format?.(value) ??
    `${dir > 0 ? '+' : ''}${value.toLocaleString('cs-CZ', { maximumFractionDigits: 1 })}`

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        good && 'bg-[color:var(--signal-good)]/15 text-[color:var(--signal-good)]',
        bad && 'bg-[color:var(--signal-bad)]/15 text-[color:var(--signal-bad)]',
        !good && !bad && 'bg-surface-2/60 text-ink-muted',
        className,
      )}
    >
      <Icon className="size-3" />
      {text}
      {suffix}
    </span>
  )
}
